import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="La pagina que buscas no existe."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Ir al inicio
        </Button>
      }
    />
  );
}
